import React from 'react';
import { Card } from '@/components/ui/card';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const TermsOfUse = () => (
  <div className="max-w-3xl mx-auto py-8 px-4" data-testid="terms-page">
    <Link to="/" className="inline-flex items-center gap-1 text-sm text-[#006030] hover:underline mb-6"><ArrowLeft className="w-4 h-4" /> Voltar</Link>
    <Card className="p-6 sm:p-8 bg-white border border-[#E2E8F0] rounded-md">
      <h1 className="text-2xl font-black text-[#0F1C2E] mb-6">Termos de Uso</h1>
      <p className="text-xs text-[#94A3B8] mb-4">Última atualização: {new Date().toLocaleDateString('pt-BR')}</p>
      <div className="space-y-4 text-sm text-[#475569] leading-relaxed">
        <section>
          <h2 className="text-base font-bold text-[#0F1C2E] mb-2">1. Descrição do Serviço</h2>
          <p>O Tô de Olho é uma plataforma de análise de dados públicos sobre candidatos e agentes políticos. Utilizamos inteligência artificial para processar informações disponíveis em fontes oficiais como o TSE (Tribunal Superior Eleitoral), Câmara dos Deputados e Senado Federal.</p>
        </section>
        <section>
          <h2 className="text-base font-bold text-[#0F1C2E] mb-2">2. Isenção de Responsabilidade</h2>
          <p>O Tô de Olho <strong>não é um órgão público</strong> e não possui qualquer vínculo com entidades governamentais. As análises são geradas automaticamente com base em dados públicos e não constituem acusação, parecer jurídico ou juízo de valor.</p>
          <p className="mt-2">As informações apresentadas têm caráter <strong>exclusivamente educativo e informativo</strong>, destinadas a auxiliar o eleitor na consulta de dados já públicos.</p>
        </section>
        <section>
          <h2 className="text-base font-bold text-[#0F1C2E] mb-2">3. Uso Permitido</h2>
          <p>A plataforma deve ser utilizada exclusivamente para consulta de informações públicas de interesse eleitoral e político. É proibido utilizar os dados para difamação, manipulação eleitoral ou qualquer finalidade ilícita.</p>
        </section>
        <section>
          <h2 className="text-base font-bold text-[#0F1C2E] mb-2">4. Conta de Usuário</h2>
          <p>O usuário é responsável por manter suas credenciais em segurança. O compartilhamento de contas é proibido. A plataforma reserva-se o direito de suspender contas que violem estes termos.</p>
        </section>
        <section>
          <h2 className="text-base font-bold text-[#0F1C2E] mb-2">5. Planos e Assinatura</h2>
          <p>A plataforma oferece um plano gratuito com funcionalidades limitadas e planos pagos (PRO) com acesso completo. Os valores e condições dos planos estão descritos na página de planos.</p>
        </section>
        <section>
          <h2 className="text-base font-bold text-[#0F1C2E] mb-2">6. Propriedade Intelectual</h2>
          <p>Todo o conteúdo da plataforma, incluindo design, código, textos e análises, é de propriedade do Tô de Olho. É proibida a reprodução sem autorização.</p>
        </section>
        <section>
          <h2 className="text-base font-bold text-[#0F1C2E] mb-2">7. Limitação de Responsabilidade</h2>
          <p>O Tô de Olho não se responsabiliza por decisões tomadas com base nas informações apresentadas. Os dados são fornecidos "como estão", com base nas fontes públicas disponíveis no momento da consulta.</p>
        </section>
        <section>
          <h2 className="text-base font-bold text-[#0F1C2E] mb-2">8. Contato</h2>
          <p>Dúvidas sobre estes termos: <strong>suporte@todeolho.app</strong></p>
        </section>
      </div>
    </Card>
  </div>
);

const CancellationPolicy = () => (
  <div className="max-w-3xl mx-auto py-8 px-4" data-testid="cancellation-page">
    <Link to="/" className="inline-flex items-center gap-1 text-sm text-[#006030] hover:underline mb-6"><ArrowLeft className="w-4 h-4" /> Voltar</Link>
    <Card className="p-6 sm:p-8 bg-white border border-[#E2E8F0] rounded-md">
      <h1 className="text-2xl font-black text-[#0F1C2E] mb-6">Política de Cancelamento</h1>
      <p className="text-xs text-[#94A3B8] mb-4">Última atualização: {new Date().toLocaleDateString('pt-BR')}</p>
      <div className="space-y-4 text-sm text-[#475569] leading-relaxed">
        <section>
          <h2 className="text-base font-bold text-[#0F1C2E] mb-2">1. Cancelamento</h2>
          <p>Você pode cancelar sua assinatura PRO a qualquer momento, sem multa ou penalidade. O cancelamento pode ser feito diretamente na plataforma ou por e-mail.</p>
        </section>
        <section>
          <h2 className="text-base font-bold text-[#0F1C2E] mb-2">2. Acesso Após Cancelamento</h2>
          <p>Após o cancelamento, o acesso às funcionalidades PRO será mantido até o final do período já pago. Após essa data, a conta retorna automaticamente ao plano gratuito.</p>
        </section>
        <section>
          <h2 className="text-base font-bold text-[#0F1C2E] mb-2">3. Renovação</h2>
          <p>Se o cancelamento for realizado, a assinatura não será renovada automaticamente no próximo ciclo.</p>
        </section>
        <section>
          <h2 className="text-base font-bold text-[#0F1C2E] mb-2">4. Reembolso</h2>
          <p>Solicitações de reembolso devem ser feitas em até 7 dias após o pagamento, por e-mail. Reembolsos serão analisados caso a caso.</p>
        </section>
        <section>
          <h2 className="text-base font-bold text-[#0F1C2E] mb-2">5. Contato</h2>
          <p>Para cancelamento ou dúvidas: <strong>suporte@todeolho.app</strong></p>
        </section>
      </div>
    </Card>
  </div>
);

export { TermsOfUse, CancellationPolicy };
